import React, { useState, useEffect } from 'react';
import { Button, Row, Col, PageHeader, notification, Select } from 'antd';
import { generateCertificateFuenteApi, getAniosCertificate } from '../../../../api/supplier';
import { getAccesTokenApi } from '../../../../api/auth';
import { certRentaPath } from '../../../../api/config';
import { getDateDocument } from '../../../../utils/functions';

const { Option } = Select;

export default function SourceWithholding(props) {
	const { id, setIsVisibleModal, setModalTitle, setModalContent } = props;
	const [value, setValue] = useState([]);
	const [from, setFrom] = useState('');
	const [to, setTo] = useState('');
	const [uploading, setUploading] = useState(false);
	const [dataAnio, setDataAnio] = useState([]);
	const [anio, setAnio] = useState('');

	const token = getAccesTokenApi();

	useEffect(() => {
		getAniosCertificate(token).then((response) => {
			if (response.estado === 'OK') {
				var data = response.resultado;
				setDataAnio(data);
				//data.map((d) => data.push(d));
				//console.log(data);
			} else {
				setDataAnio([]);
			}
		});
	}, []);

	const changeAnio = (value) => {
		setAnio(value);
	};

	const GenerateCertificate = () => {
		setUploading(true);
		if (anio === '') {
			notification['error']({
				message: 'Debe seleccionar el año para generar certificado',
			});
			setUploading(false);
		} else {
			generateCertificateFuenteApi(token, id, anio).then((response) => {
				if (response.estado === 'OK') {
					var today = getDateDocument();
					const pdfCer = `${certRentaPath}/${response.resultado}?${today}`;
					viewCertificatePDF(pdfCer);
					setAnio('');
				} else {
					notification['error']({
						message: 'Error Generando Certificado: ' + response.resultado,
					});
				}
				setUploading(false);
			});
		}
	};

	const viewCertificatePDF = (pdfCer) => {
		//
		setModalTitle(`Consultar Certificado Retención de Fuente ${id}`);
		setIsVisibleModal(true);
		setModalContent(
			<div id="imgConCert">
				<iframe id="pdfCert" src={pdfCer} style={{ width: '70vw', height: '90vw' }}></iframe>
			</div>
		);
	};

	return (
		<div>
			<PageHeader title="Certificado " subTitle=" de Retencion de Renta" />

			<Row>
				<Col span={6} className="head">
					Seleccione el año que desea generar el certificado:
				</Col>
				<Col span={14} className="name">
					<Select
						//mode="multiple"
						//labelInValue
						value={anio}
						placeholder="Seleccione Año..."
						//notFoundContent={fetching ? <Spin size="small" /> : null}
						filterOption={false}
						//onSearch={this.fetchUser}
						onChange={changeAnio}
						style={{ width: '90%' }}
					>
						{dataAnio.map((d) => (
							<Option key={d.anio}>{d.anio}</Option>
						))}
					</Select>
				</Col>
				<Col span={4} className="head">
					<Button
						type="primary"
						onClick={GenerateCertificate}
						//disabled={disabled}
						loading={uploading}
						//style={{ marginTop: 16, marginLeft: 10 }}
					>
						{uploading ? 'Generando Certificado...' : 'Generar Certificado'}
					</Button>
				</Col>
			</Row>
		</div>
	);
}
